module.exports = __webpack_public_path__ + "img/symanteclogo-small.ca34937f.png";